module.exports = __webpack_public_path__ + "img/check_role.13599867.svg";